import React from "react";
import Paragraph from "../../components/common/Typography/Paragraph";
import Heading from "../../components/common/Typography/Heading";
import SpecialText from "../../components/common/Typography/SpecialText";
import { publicMainHeaderOffsetClass } from "../Public/shared/publicLayoutSpec";

const StaticHeroSection = () => {

  return (
    <section 
      className={`relative h-[150vh] ${publicMainHeaderOffsetClass()} pb-0 overflow-hidden`}
    >
      <div className="container h-full mx-auto px-6 relative z-10 flex items-center justify-center">
        {/* Central Content */}
        <div className="text-center max-w-4xl mx-auto relative">
          {/* Brand Name */}
          <Heading
          variant={"h1"}
          className="!capitalize text-primaryblue mb-5 text-center"
          >
            For Trade Professionals<br />
            <span className="text-offblack">Ready to Be Found.</span>
          </Heading>

          {/* Subtitle */}
          <SpecialText 
            variant={"IntroParagraph"}
            className="!text-offblack max-w-3xl mx-auto leading-relaxed"
          >
            Create a profile, publish real work, and reach by verified customers directly no bidding wars, no commission cuts. Just your trade, your terms, your control.
          </SpecialText>
        </div>

        {/* Scattered Feature Icons - Trade Professional Benefits */}
        
        {/* Top Row - Professional Features */}
        {/* No Commission - Top Left */}
        <div 
          className="absolute top-[3.6%] left-[15%] scale-[2.1]"
        >
          <div className="w-16 h-16 md:w-20 md:h-20 bg-[#0b5cff] rounded-xl flex flex-col items-center justify-center transform shadow-[0_1px_1px_1px_rgba(0,0,0,0.1)]">
            <div className="relative">
              <span className="text-white font-bold text-lg md:text-xl">%</span>
            </div>
            <span className="text-[8px] md:text-[9px] font-medium text-white text-center leading-tight tracking-wide mt-0.5">No Commission</span>
          </div>
        </div>

        {/* Verified Customers - Top Center Left */}
        <div 
          className="absolute top-[24%] left-[25%] scale-[1.1]"
        >
          <div className="w-16 h-16 md:w-20 md:h-20 bg-[#ea580c] rounded-xl flex flex-col items-center justify-center shadow-[0_1px_1px_1px_rgba(0,0,0,0.1)]">
            <svg className="w-5 h-5 md:w-6 md:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
                         <span className="text-[8px] md:text-[9px] font-medium text-white text-center leading-tight tracking-wide mt-0.5">Verified<br/>Customers</span>
          </div>
        </div>

        {/* Direct Communication - Top Center Right */}
        <div 
          className="absolute top-4 right-[28%] md:top-8 md:right-[30%]"
        >
          <div className="w-16 h-16 md:w-20 md:h-20 bg-indigo-600 rounded-xl flex flex-col items-center justify-center shadow-xl shadow-indigo-300/20">
            <svg className="w-5 h-5 md:w-6 md:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
            </svg>
                         <span className="text-[8px] md:text-[9px] font-medium text-white text-center leading-tight tracking-wide mt-0.5">Direct<br/>Communication</span>
          </div>
        </div>

        {/* Own Payment Terms - Top Right Area */}
        <div 
          className="absolute top-[10%] left-[40%] scale-[1.5]"
        >
          <div className="w-16 h-16 md:w-20 md:h-20 bg-teal-600 rounded-xl flex flex-col items-center justify-center shadow-xl shadow-teal-300/20">
            <svg className="w-5 h-5 md:w-6 md:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
                         <span className="text-[8px] md:text-[9px] font-medium text-white text-center leading-tight tracking-wide mt-0.5">Own Payment<br/>Terms</span>
          </div>
        </div>

        {/* Create Posts - Top Right */}
        <div 
          className="absolute top-2 right-[4%] md:top-4 md:right-[6%]"
        >
          <div className="w-16 h-16 md:w-20 md:h-20 bg-orange-600 rounded-xl flex flex-col items-center justify-center shadow-xl shadow-orange-300/20">
            <svg className="w-5 h-5 md:w-6 md:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            <span className="text-[8px] md:text-[9px] font-medium text-white text-center leading-tight tracking-wide mt-0.5">Create Your<br/>Own Posts</span>
          </div>
        </div>

        {/* Left Side Middle Icons */}
        {/* Professional Label - Left Side */}
        {/* <div className="absolute top-[35%] left-[12%] md:top-[38%] md:left-[15%] transform -translate-y-1/2">
          <span className="text-gray-500 text-sm md:text-base font-medium">Professional</span>
        </div> */}

        {/* Advanced Profile - Below Label */}
        <div 
          className="absolute top-[42%] left-[8%] md:top-[45%] md:left-[12%] transform -translate-y-1/2"
        >
          <div className="w-16 h-16 md:w-20 md:h-20 bg-indigo-600 rounded-xl flex flex-col items-center justify-center shadow-xl shadow-indigo-300/20">
            <svg className="w-5 h-5 md:w-6 md:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            <span className="text-[8px] md:text-[9px] font-medium text-white text-center leading-tight tracking-wide mt-0.5">Advanced<br/>Profile</span>
          </div>
        </div>

        {/* Advanced Dashboard - Center Left */}
        <div 
          className="absolute top-[27%] right-[20%] transform -translate-y-1/2 scale-[1.3]"
        >
          <div className="w-16 h-16 md:w-20 md:h-20 bg-cyan-600 rounded-xl flex flex-col items-center justify-center shadow-xl shadow-cyan-300/20">
            <svg className="w-5 h-5 md:w-6 md:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
            <span className="text-[8px] md:text-[9px] font-medium text-white text-center leading-tight tracking-wide mt-0.5">Advanced<br/>Dashboard</span>
          </div>
        </div>

        {/* Right Side Icons */}
        {/* Analytics & Metrics - Right Side */}
        <div 
          className="absolute top-[48%] right-[4%] md:top-[52%] md:right-[6%]"
        >
          <div className="w-16 h-16 md:w-20 md:h-20 bg-pink-600 rounded-xl flex flex-col items-center justify-center shadow-xl shadow-pink-300/20">
            <svg className="w-5 h-5 md:w-6 md:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
            <span className="text-[8px] md:text-[9px] font-medium text-white text-center leading-tight tracking-wide mt-0.5">Analytics &<br/>Metrics</span>
          </div>
        </div>

        {/* No Fake Leads - Right Side */}
        <div 
          className="absolute top-[58%] right-[8%] md:top-[62%] md:right-[15%]"
        >
          <div className="w-16 h-16 md:w-20 md:h-20 bg-red-600 rounded-xl flex flex-col items-center justify-center shadow-xl shadow-red-300/20">
            <svg className="w-5 h-5 md:w-6 md:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
            <span className="text-[8px] md:text-[9px] font-medium text-white text-center leading-tight tracking-wide mt-0.5">No Fake Leads</span>
          </div>
        </div>

        {/* No Bidding - Right Bottom */}
        <div 
          className="absolute bottom-[25%] right-[4%] md:bottom-[5%] md:right-[6%]"
        >
          <div className="w-16 h-16 md:w-20 md:h-20 bg-gray-700 rounded-xl flex flex-col items-center justify-center shadow-xl shadow-gray-300/20">
            <svg className="w-5 h-5 md:w-6 md:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
            <span className="text-[8px] md:text-[9px] font-medium text-white text-center leading-tight tracking-wide mt-0.5">No Bidding</span>
          </div>
        </div>

        {/* Bottom Row Icons */}
        {/* Monthly Plan - Far Left */}
        <div 
          className="absolute bottom-[8%] left-[2%] md:bottom-[12%] md:left-[4%]"
        >
          <div className="w-16 h-16 md:w-20 md:h-20 bg-violet-600 rounded-xl flex flex-col items-center justify-center shadow-xl shadow-violet-300/20">
            <svg className="w-5 h-5 md:w-6 md:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <span className="text-[8px] md:text-[9px] font-medium text-white text-center leading-tight tracking-wide mt-0.5">Monthly Plan</span>
          </div>
        </div>

        {/* Compliance Badges - Bottom Left */}
        <div 
          className="absolute bottom-[0%] left-[18%] md:bottom-[0%] md:left-[20%]"
        >
          <div className="w-16 h-16 md:w-20 md:h-20 bg-amber-600 rounded-xl flex flex-col items-center justify-center shadow-xl shadow-amber-300/20">
            <svg className="w-5 h-5 md:w-6 md:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
            </svg>
            <span className="text-[8px] md:text-[9px] font-medium text-white text-center leading-tight tracking-wide mt-0.5">Compliance<br/>Badges</span>
          </div>
        </div>

        {/* Portfolio Gallery - Bottom Center */}
        <div 
          className="absolute bottom-[8%] left-[32%] md:bottom-[12%] md:left-[35%]"
        >
          <div className="w-16 h-16 md:w-20 md:h-20 bg-teal-600 rounded-xl flex flex-col items-center justify-center shadow-xl shadow-teal-300/20">
            <svg className="w-5 h-5 md:w-6 md:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <span className="text-[8px] md:text-[9px] font-medium text-white text-center leading-tight tracking-wide mt-0.5">Portfolio<br/>Gallery</span>
          </div>
        </div>

      </div>
    </section>
  );
};

export default StaticHeroSection; 